import {
  PartnerSchema,
  PartnerListResponseSchema,
  type Partner,
  type PartnerListQueryInput,
  type PartnerListResponse,
} from '../contracts/partners';
import { CitiesResponseSchema, type CitiesResponse } from '../contracts/handles';
import type { QueryValue, RequestFn } from './client';

/**
 * Namespace `client.partners` — обёртки над эндпоинтами Блока 8 «Партнёры». Спека —
 * ADR-0080 §2/§3. Зеркалит `furniture.ts`.
 *
 * Контакты партнёра публичны (гость, не за soft-gate — решение владельца 2026-06-14,
 * как в прототипе): ни один метод не `auth: true`.
 *
 * `id` в path — `encodeURIComponent` (P-001 verbatim round-trip: `/`, `(`, `)`,
 * пробелы; handler делает `decodeURIComponent` и получает ровно отправленное).
 */
export interface PartnersApi {
  /** GET /api/partners?category=&subcategory=&city= — список по фильтру (2.8.2). */
  list(query: PartnerListQueryInput): Promise<PartnerListResponse>;
  /** GET /api/partners/:id — карточка партнёра (2.8.3). */
  get(id: string): Promise<Partner>;
  /** GET /api/partners/cities — города с партнёрами (дефолт/наличие города). */
  cities(): Promise<CitiesResponse>;
}

export function createPartnersApi(request: RequestFn): PartnersApi {
  return {
    list: (query) =>
      request({
        method: 'GET',
        path: '/api/partners',
        query: queryToParams(query),
        responseSchema: PartnerListResponseSchema,
      }),

    get: (id) =>
      request({
        method: 'GET',
        path: `/api/partners/${encodeURIComponent(id)}`,
        responseSchema: PartnerSchema,
      }),

    cities: () =>
      request({
        method: 'GET',
        path: '/api/partners/cities',
        responseSchema: CitiesResponseSchema,
      }),
  };
}

function queryToParams(q: PartnerListQueryInput): Record<string, QueryValue> {
  return {
    category: q.category,
    subcategory: q.subcategory,
    city: q.city,
    cursor: q.cursor,
    limit: q.limit !== undefined ? Number(q.limit) : undefined,
  };
}
